'use strict'
import React from 'react'
import { Link } from 'react-router-dom'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'

/**
 * Standard breadcrumb component for the Routing module to provide
 * consistent navigation back to main areas.
 * 
 * @param {{ items: Array<{label: string, path?: string}> }} props
 */
export default function RoutingBreadcrumbs ({ items = [] }) {
  return (
    <nav style={{ 
      display: 'flex', alignItems: 'center', gap: 6, 
      marginBottom: 16, fontSize: 13, fontWeight: 600,
      color: 'var(--df-ink-3)', flexWrap: 'wrap'
    }}>

      <Link 
        to="/routing" 
        style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.12s' }}
        onMouseEnter={e => e.currentTarget.style.color = 'var(--df-ink)'}
        onMouseLeave={e => e.currentTarget.style.color = 'inherit'}
      >
        Dashboard
      </Link>
      {items.map((item, idx) => (
        <React.Fragment key={idx}>
          <ChevronRightIcon style={{ fontSize: 14, color: 'var(--df-line-2)' }} />
          {item.path ? (
            <Link 
              to={item.path} 
              style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.12s' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--df-ink)'}
              onMouseLeave={e => e.currentTarget.style.color = 'inherit'}
            >
              {item.label}
            </Link>
          ) : (
            <span style={{ color: 'var(--df-ink)' }}>{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  )
}
